import React, {ReactElement, useCallback, useState} from 'react';
import {ReactComponent as IconUp} from '../../../assets/image/library/chevron-up.svg';
import {ReactComponent as IconDown} from '../../../assets/image/library/chevron-down.svg';
import {Collapse} from 'react-collapse';

import './styles.scss';

type ExerciseCollapseProps = {
  title: string
  collapsed: boolean
  children?: ReactElement | null
};

export const ExerciseCollapse: React.FC<ExerciseCollapseProps> = ({children, title, collapsed}: ExerciseCollapseProps) => {
  const [isCollapseOpen, setIsCollapseOpen] = useState(!collapsed);

  const onClick = useCallback(
    () => setIsCollapseOpen(!isCollapseOpen),
    [isCollapseOpen]
  );

  return <div className="exercise-collapse">
    <button className="exercise-collapse__header" aria-expanded={isCollapseOpen} onClick={onClick}>
      <div className="exercise-collapse__title">
        {title}
      </div>
      {isCollapseOpen ? <IconUp className="exercise-collapse__arrow" /> : <IconDown className="exercise-collapse__arrow" />}
    </button>
    <Collapse
      isOpened={isCollapseOpen}>
      <div className="exercise-collapse__content">
        {children}
      </div>
    </Collapse>
  </div>;
};
